import React, { useState, useEffect } from 'react';
import './GestionBourses.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminNavigationBar from '../../components/AdminNavigationBar';
import { EditIcon, DeleteIcon } from '../../components/Icons';

function GestionBourses() {
  const [bourses, setBourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    titre: '',
    organisme: '',
    description: '',
    montant: '',
    date_limite: '',
    conditions: '',
    contact: '',
    email: '',
    lien: ''
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchBourses();
  }, []);

  const fetchBourses = async () => {
    try {
      setLoading(true);
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/opportunites');
      const data = await response.json();
      // Filtrer uniquement les bourses (type = 'bourse')
      const allOpportunites = data.data || data || [];
      const boursesOnly = allOpportunites.filter(opp => opp.type === 'bourse');
      setBourses(boursesOnly);
      setLoading(false);
    } catch (error) {
      console.error('Erreur lors du chargement des bourses:', error);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = editingId 
        ? `http://127.0.0.1:8000/api/v1/admin/opportunites/${editingId}`
        : 'http://127.0.0.1:8000/api/v1/admin/opportunites';
      
      // Ajouter le type 'bourse' aux données
      const dataToSend = {
        ...formData,
        type: 'bourse',
        contenu: formData.description, // Mapper description vers contenu
        lien_candidature: formData.lien // Mapper lien vers lien_candidature
      };

      // Pour les mises à jour, utiliser POST avec _method
      const method = editingId ? 'POST' : 'POST';
      if (editingId) {
        dataToSend._method = 'PUT';
      }
      
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend)
      });

      const responseData = await response.json();

      if (response.ok) {
        alert(editingId ? 'Bourse modifiée avec succès' : 'Bourse créée avec succès');
        fetchBourses();
        setFormData({
          titre: '',
          organisme: '',
          description: '',
          montant: '',
          date_limite: '',
          conditions: '',
          contact: '',
          email: '',
          lien: ''
        });
        setShowForm(false);
        setEditingId(null);
      } else {
        console.error('Erreur réponse:', responseData);
        alert(`Erreur lors de l'enregistrement: ${responseData.message || 'Erreur inconnue'}`);
      }
    } catch (error) {
      console.error('Erreur complète:', error);
      alert(`Erreur lors de la sauvegarde: ${error.message}`);
    }
  };

  const handleEdit = (bourse) => {
    setFormData({
      titre: bourse.titre || '',
      organisme: bourse.organisme || '',
      description: bourse.contenu || bourse.description || '',
      montant: bourse.montant || '',
      date_limite: bourse.date_limite || '',
      conditions: bourse.conditions || '',
      contact: bourse.contact || '',
      email: bourse.email || '',
      lien: bourse.lien_candidature || bourse.lien || ''
    });
    setEditingId(bourse.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette bourse?')) {
      try {
        await fetch(`http://127.0.0.1:8000/api/v1/admin/opportunites/${id}`, {
          method: 'DELETE'
        });
        fetchBourses();
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
      }
    }
  };

  if (loading) {
    return (
      <div className="admin-layout">
        <DashboardHeader />
        <AdminNavigationBar 
          title="Gestion des Bourses" 
          onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
        />
        <div className="admin-container">
          <main className="admin-content admin-content-full">
            <div className="loading-state">Chargement...</div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Gestion des Bourses" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="gestion-header">
            <button 
              className="btn btn-primary"
              onClick={() => {
                setShowForm(!showForm);
                setEditingId(null);
                setFormData({
                  titre: '',
                  organisme: '',
                  description: '',
                  montant: '',
                  date_limite: '',
                  conditions: '',
                  contact: '',
                  email: '',
                  lien: ''
                });
              }}
            >
              {showForm ? 'Annuler' : 'Ajouter une Bourse'}
            </button>
          </div>

          {showForm && (
            <div className="form-card">
              <h2>{editingId ? 'Modifier la Bourse' : 'Ajouter une Nouvelle Bourse'}</h2>
              <form onSubmit={handleSubmit} className="gestion-form">
                <div className="form-row">
                  <input
                    type="text"
                    name="titre"
                    placeholder="Titre de la bourse"
                    value={formData.titre}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="text"
                    name="organisme"
                    placeholder="Organisme"
                    value={formData.organisme}
                    onChange={handleChange}
                    required
                  />
                </div>

                <textarea
                  name="description"
                  placeholder="Description de la bourse"
                  value={formData.description}
                  onChange={handleChange}
                  rows="4"
                  required
                ></textarea>

                <div className="form-row">
                  <input
                    type="text"
                    name="montant"
                    placeholder="Montant"
                    value={formData.montant}
                    onChange={handleChange}
                  />
                  <input
                    type="date"
                    name="date_limite"
                    value={formData.date_limite}
                    onChange={handleChange}
                  />
                </div>

                <textarea
                  name="conditions"
                  placeholder="Conditions d'accès"
                  value={formData.conditions}
                  onChange={handleChange}
                  rows="3"
                ></textarea>

                <div className="form-row">
                  <input
                    type="text"
                    name="contact"
                    placeholder="Contact"
                    value={formData.contact}
                    onChange={handleChange}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                <input
                  type="url"
                  name="lien"
                  placeholder="Lien vers plus d'informations"
                  value={formData.lien}
                  onChange={handleChange}
                />

                <button type="submit" className="btn btn-primary">
                  {editingId ? 'Modifier' : 'Ajouter'}
                </button>
              </form>
            </div>
          )}

          <div className="table-card">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Titre</th>
                  <th>Organisme</th>
                  <th>Montant</th>
                  <th>Date Limite</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {bourses.map((bourse) => (
                  <tr key={bourse.id}>
                    <td>{bourse.titre}</td>
                    <td>{bourse.organisme}</td>
                    <td>{bourse.montant}</td>
                    <td>{bourse.date_limite}</td>
                    <td className="action-buttons">
                      <button 
                        className="action-btn edit-btn"
                        onClick={() => handleEdit(bourse)}
                        title="Modifier"
                      >
                        <EditIcon size={16} />
                      </button>
                      <button 
                        className="action-btn delete-btn"
                        onClick={() => handleDelete(bourse.id)}
                        title="Supprimer"
                      >
                        <DeleteIcon size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  );
}

export default GestionBourses;
